export const SET_SCENARIO = "SET_SCENARIO";
export const MODIFY_SCENARIO_PROPERTY = "MODIFY_SCENARIO_PROPERTY";
export const MODIFY_SCENARIO_MASS_PROPERTY = "MODIFY_SCENARIO_MASS_PROPERTY";
export const ADD_MASS = "ADD_MASS";
export const DELETE_MASS = "DELETE_MASS";
